import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteProfileDocument = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/profile_document/${id}/`,
      {
        headers: {
          Authorization: authHeader,
        },
      },
    );
  });
};
